import { render, staticRenderFns } from "./ModelDocumentation.vue?vue&type=template&id=91da4c44&scoped=true"
import script from "./ModelDocumentation.vue?vue&type=script&lang=js"
export * from "./ModelDocumentation.vue?vue&type=script&lang=js"
import style0 from "@/assets/docs/styles/documentation.css?vue&type=style&index=0&id=91da4c44&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91da4c44",
  null
  
)

export default component.exports